import { supabase } from './supabase';
import { extractFunctionErrorMessage } from '../utils/supabaseFunctionError';

// Servicio separado de services/aplicacionesFertilizantes.js a propósito:
// las reglas de autorización son distintas (ADMIN ve TODAS las
// aplicaciones de fertilizantes, un encargado solo las suyas) y viven en
// una Edge Function + RPC propias (admin-fertilizantes -> admin_*_fertilizantes),
// nunca en SELECT directo — no existe policy RLS que permita a ADMIN leer
// public.encargados, y una consulta con paginación/joins/conteo de
// productos sin N+1 no es viable como SELECT plano desde el cliente.
//
// Mismo patrón exacto que services/adminAplicaciones.js.

const FUNCTION_NAME = 'admin-fertilizantes';
const GENERIC_ERROR = 'No se pudo completar la operación. Intenta nuevamente.';

async function invoke(body) {
  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, { body });
  if (error) {
    const message = await extractFunctionErrorMessage(error);
    return { ok: false, message: message || GENERIC_ERROR };
  }
  return { ok: true, data };
}

export async function obtenerResumenFertilizantesAdmin() {
  const result = await invoke({ accion: 'RESUMEN' });
  if (!result.ok) return result;
  return { ok: true, resumen: result.data?.resumen ?? null };
}

export async function obtenerFiltrosFertilizantesAdmin() {
  const result = await invoke({ accion: 'CATALOGOS' });
  if (!result.ok) return result;
  return {
    ok: true,
    productores: result.data?.catalogos?.productores ?? [],
    encargados: result.data?.catalogos?.encargados ?? [],
  };
}

// filtros: { page, pageSize, estado, idproductor, authUserIdEncargado,
// fechaDesde, fechaHasta, busqueda } — todos opcionales.
export async function listarFertilizantesAdmin(filtros = {}) {
  const result = await invoke({
    accion: 'LISTAR',
    page: filtros.page ?? 1,
    page_size: filtros.pageSize ?? 25,
    estado: filtros.estado ?? null,
    idproductor: filtros.idproductor ?? null,
    auth_user_id_encargado: filtros.authUserIdEncargado ?? null,
    fecha_desde: filtros.fechaDesde ?? null,
    fecha_hasta: filtros.fechaHasta ?? null,
    busqueda: filtros.busqueda ?? null,
  });
  if (!result.ok) return result;

  const resultado = result.data?.resultado ?? {};
  return {
    ok: true,
    aplicaciones: resultado.items ?? [],
    total: resultado.total ?? 0,
    page: resultado.page ?? 1,
    pageSize: resultado.page_size ?? 25,
  };
}

export async function obtenerFertilizanteAdmin(id) {
  const result = await invoke({ accion: 'DETALLE', aplicacion_id: Number(id) });
  if (!result.ok) return result;
  return { ok: true, aplicacion: result.data?.aplicacion ?? null };
}
